export var controls = {
    height: {
        /** 20px */
        paper: '20px',
        /** 24px */
        wafer: '24px',
        /** 32px */
        thin: '32px',
        /** 40px */
        default: '40px',
        /** 48px */
        thick: '48px'
    }
};
//# sourceMappingURL=controls.js.map